module.exports = __webpack_public_path__ + "img/dots-vertical.e7fa9cd1.svg";